<script>
    export let value;
    export let inputClass = "";
    export let isDisabled = false;

    const disableKeyboardArrow = () => {
        document.onkeydown = ({ keyCode }) => {
            if (keyCode === 38 || keyCode === 40 || keyCode === 189)
                return false;
        };
    };

    // HELPER FUNCTIONS
    const _validateInput = (evt) => {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === "paste") {
            key = event.clipboardData.getData("text/plain");
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\./;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    };

    const _convertPercentageToNumber = () => {
        if (value) value = Number(value.toString().replace("%", ""));
        else value = "";
    };

    const _convertNumberToPercentage = () => {
        if (value) value = Number(value) + " %";
        else value = "";
    };
</script>

<input
    type="text"
    class={`input input-sm input-bordered ${inputClass}`}
    placeholder={!value ? "0 %" : ""}
    disabled={isDisabled}
    bind:value
    on:click|preventDefault={disableKeyboardArrow}
    on:keypress={_validateInput}
    on:mousewheel|preventDefault={() => {
        true;
    }}
    on:focus={({ target }) => {
        target.type = "number";
        _convertPercentageToNumber();
    }}
    on:blur={({ target }) => {
        target.type = "text";
        _convertNumberToPercentage();
    }}
    required
/>
